import { ASW_S3_LINK } from '../configurations/api/url';

/** Domain types + pure helpers only. HTTP lives in redux/sandbox sagas. */

export type SandboxCourse = {
    _id: string;
    title: string;
    slug?: string;
    description?: string;
    cover_image?: string | null;
    social_thumbnail?: string | null;
    categories?: string[];
    mastery_tier?: 'beginner' | 'intermediate' | 'masterclass';
    pricing_mode?: 'pro_pass' | 'standalone';
    office_hours_enabled?: boolean;
    status?: string;
    featured?: boolean;
    price_cents?: number;
    currency?: string;
    with_subscriber_discount?: boolean;
    subscriber_discount?: number;
    is_free_for_subscriber?: boolean;
    enrollment_count?: number;
    rating_avg?: number;
    rating_count?: number;
    lesson_count?: number;
    module_count?: number;
    teacher?: {
        _id?: string;
        firstName?: string;
        lastName?: string;
        userName?: string;
        photo?: string;
        profile_picture?: string;
    };
    modules?: Array<{
        _id: string;
        title: string;
        order?: number;
        lessons?: Array<{
            _id: string;
            title: string;
            description?: string;
            order?: number;
            duration_seconds?: number;
            has_assignment?: boolean;
            assignment_brief?: string;
            project?: string | null;
            is_free_preview?: boolean;
        }>;
    }>;
    class_assets?: SandboxClassAsset[];
    class_asset_count?: number;
};

export type SandboxClassAsset = {
    _id: string;
    name: string;
    description?: string;
    file_size_bytes?: number;
    original_filename?: string;
    createdAt?: string;
};

export type SandboxAssignmentSubmission = {
    _id: string;
    status: 'submitted' | 'in_review' | 'passed' | 'revision_requested' | 'rejected' | string;
    notes?: string;
    teacher_review?: string;
    teacher_rating?: number | null;
    reviewed_at?: string | null;
    createdAt?: string;
    project?: { _id?: string; title?: string; feature_image?: string; thumbnail?: string } | string;
};

export type SandboxCourseRating = {
    _id?: string;
    rating: number;
    review?: string;
    createdAt?: string;
    updatedAt?: string;
    user?: {
        _id?: string;
        firstName?: string;
        lastName?: string;
        userName?: string;
        photo?: string;
    };
};

export type SandboxPaymentHistoryItem = {
    id: string;
    type: 'course' | 'office_hours' | 'payout';
    direction: 'credit' | 'debit';
    amount_cents: number;
    status: string;
    title: string;
    subtitle?: string;
    created_at?: string;
    session_at?: string;
    available_at?: string | null;
};

export function formatSandboxPrice(cents?: number, currency = 'USD') {
    const amount = (Number(cents) || 0) / 100;
    try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount);
    } catch {
        return `$${amount.toFixed(2)}`;
    }
}

/** Prefix S3 object keys with the media CDN (same pattern as contests/projects). */
export function resolveSandboxMediaUrl(path?: string | null): string | null {
    if (!path) return null;
    const trimmed = String(path).trim();
    if (!trimmed) return null;
    if (/^(https?:|data:|blob:)/i.test(trimmed)) return trimmed;
    const base = (ASW_S3_LINK || '').replace(/\/?$/, '/');
    const key = trimmed.replace(/^\//, '');
    return `${base}${key}`;
}
